import { dateLabels, instantLabels } from '@/lib/dates';
import { cn } from '@/lib/utils';

/** Hebrew date first, Gregorian second; Shabbat shows the parasha (UI rule in CLAUDE.md). */
export function DateDisplay({ value, className, inline, showParasha = true }: {
  value: Date | string; className?: string; inline?: boolean; showParasha?: boolean;
}) {
  const l = dateLabels(value);
  const parasha = showParasha && l.parasha ? `שבת ${l.parasha}` : null;
  if (inline) {
    return (
      <span className={cn('whitespace-nowrap', className)}>
        {l.hebrew} <span className="text-muted">· <span className="ltr">{l.gregorian}</span></span>
        {parasha ? <span className="text-gold-ink"> · {parasha}</span> : null}
      </span>
    );
  }
  return (
    <span className={cn('inline-flex flex-col leading-tight', className)}>
      <span className="font-medium">{l.hebrew}</span>
      <span className="text-xs text-muted">
        <span className="ltr">{l.gregorian}</span>
        {parasha ? <span className="text-gold-ink"> · {parasha}</span> : null}
      </span>
    </span>
  );
}

/** For Firestore timestamps (audit, logs): Hebrew date + Gregorian + time. */
export function InstantDisplay({ value, className }: { value: unknown; className?: string }) {
  const l = instantLabels(value);
  if (!l) return <span className="text-muted">—</span>;
  return (
    <span className={cn('inline-flex flex-col leading-tight', className)}>
      <span className="font-medium">{l.hebrew}</span>
      <span className="text-xs text-muted">
        <span className="ltr">{l.gregorian} {l.time}</span>
      </span>
    </span>
  );
}
